var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pack-name",class:_vm.packClass},[_c('img',{attrs:{"src":_vm.packIcon,"alt":"pack-icon"}}),_c('span',{staticClass:"pack-name__text"},[_vm._v("\n    "+_vm._s(_vm.$t(`suscriptions.names.${_vm.packName}`))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }